.root {
    border: 1px solid var(--border-color);
    border-radius: 0.5rem;

    display: flex;
    flex-direction: column;
    position: relative;
    overflow: hidden;

    .header {
        margin: 0;
        position: relative;
        padding: 0.75rem 1rem;
        background: #d7e3ef;
    }

    .action-block{
        border-top: 1px solid #e4e8f1;
        padding: 0.5rem;
        background: #edf1f5 /*#efefef*/;
    }
}